import { StandardQuestionUploadDTO } from "../../../common/types/common.dto.types";
import {
  Box,
  Typography as MuiTypography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Danger,
} from "../../../common/utils/mui-imports";
import { BulkUploadValidateQuestionProps } from "./BulkUploadValidateQuestion.types";

const BulkUploadValidateQuestion: React.FC<BulkUploadValidateQuestionProps> = (
  props
) => {
  return (
    <>
      {" "}
      {/* Action Message */}
      <div>
        <MuiTypography style={{ marginBottom: "20px" }} variant="body2">
          Action Needed: The uploaded file{" "}
          <span className="bulk-upload-action-file">
            '{props.UploadedFileName ?? ""}'
          </span>
          contains issue(s). You can either fix the identified issue(s) and
          reupload the file, or proceed with only the valid requirements.
        </MuiTypography>
      </div>
      <div className="questions-section">
        {/* Valid Questions Section */}
        <div className="valid-section">
          <h4 className="validation-section-title validation-section-title--valid">
            Valid Question(s)
          </h4>
          <MuiTypography
            variant="body2"
            className="validation-section-subtitle"
          >
            {props.QuestionCount?.ValidQuestionCount}/
            {props.QuestionCount?.TotalQuestionCount} question(s) are valid and
            meet the required conditions
          </MuiTypography>
        </div>

        {/* Questions with Issues Section */}
        <div className="validation-section">
          <h4
            style={{ paddingTop: "10px" }}
            className="validation-section-title validation-section-title--issues"
          >
            Question(s) with issue(s)
          </h4>
          <MuiTypography
            variant="body2"
            className="validation-section-subtitle"
          >
            {props.QuestionCount?.WarningQuestionCount}/
            {props.QuestionCount?.TotalQuestionCount} question(s) contains
            issue(s)
          </MuiTypography>

          <p className="validation-section-description">
            It is recommended to correct the following errors in the uploaded
            Excel sheet before proceeding.
          </p>

          {/* Issues Table */}
          <TableContainer
            component={Box}
            className="validation-issues-table-container"
          >
            <Table
              stickyHeader
              className="validation-issues-table"
              size="small"
            >
              <TableHead>
                <TableRow
                  style={{ backgroundColor: "red !important" }}
                  className="validation-table-header"
                >
                  <TableCell className="validation-table-header-cell validation-table-header-cell--rid">
                    Excel Row ID
                  </TableCell>
                  <TableCell className="validation-table-header-cell validation-table-header-cell--requirement">
                    Requirement
                  </TableCell>
                  <TableCell className="validation-table-header-cell validation-table-header-cell--issues">
                    <Box className="validation-issues-header-content">
                      <Danger
                        style={{ marginRight: "5px" }}
                        size="22"
                        color="#e40300 "
                      />
                      Issue(s) Found
                    </Box>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.StandardQuestionsWithWarnings?.map(
                  (question: StandardQuestionUploadDTO, index: number) => {
                    return (
                      <TableRow className="validation-table-row" key={index}>
                        <TableCell className="validation-table-cell validation-table-cell--rid">
                          R{question.DisplayId}
                        </TableCell>
                        <TableCell className="validation-table-cell">
                          {question.Requirement}
                        </TableCell>
                        <TableCell className="validation-table-cell validation-table-cell--issues">
                          {question.Warning}
                        </TableCell>
                      </TableRow>
                    );
                  }
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </>
  );
};

export default BulkUploadValidateQuestion;
